const useIsNativeApp = () => {
    return !!window?.navigator?.userAgent?.includes("MyBenefit");
};

export default useIsNativeApp;